"use client";

import { useState } from "react";
import { FileText } from "lucide-react";
import { Button } from "../ui/button";

/**
 * Floating Notepad launcher.
 * - md and up: round 56px button on the right edge, just below Magic Editor (unchanged).
 * - mobile: small 40px button stacked above the chat-bot launcher.
 * Hidden on mobile while the product tour is running (see `.tour-hide-on-mobile`).
 */
export default function NotepadEditorButton({ onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="tour-hide-on-mobile fixed right-6 bottom-[5.25rem] z-40 md:bottom-auto md:top-1/2 md:-translate-y-1/2 md:mt-16">
      <Button
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          w-10 h-10 md:w-14 md:h-14 p-0 rounded-full shadow-lg transition-all duration-300
          bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700
          ${isHovered ? 'md:scale-110 shadow-xl' : 'scale-100'}
        `}
        title="Notepad Editor"
        aria-label="Notepad Editor"
      >
        <FileText className="w-5 h-5 md:w-6 md:h-6 text-white" />
      </Button>
      
      {/* Tooltip */}
      {isHovered && (
        <div className="hidden md:block absolute right-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap">
          Notepad Editor
          <div className="absolute right-0 top-1/2 transform translate-x-1 -translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
        </div>
      )}
    </div>
  );
}
